import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { DetailComponent } from '@app/common/templates/detail/detail.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from '@environments/environment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: './detail.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/detail/style.scss'],
	providers: [MessageService, ConfirmationService]
})
export class TblMitarbeiterDetailComponent extends DetailComponent {
	//env_supportmail: string = '';

	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		@Optional() public config?: DynamicDialogConfig,
		@Optional() public ref?: DynamicDialogRef,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, messageService, router, translate, config, ref);

		this.env_supportmail = environment.supportEmail;
		if(!this.env_supportmail || this.env_supportmail.trim().length < 1) {
			this.env_supportmail = 'support@visy-gmbh.com';
		}
		this.apiUrl = 'TblMitarbeiter';
		this.name = 'MENU.MITARBEITER';
		this.url = '/' + PATH.MITARBEITER;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'object', key: 'FREMD_anrede_bezeichnung', required: false, width: 400, url: '/' + PATH.ANREDE, id: 'anrede_id' },
				{ type: 'text', key: 'vorname1', required: false, width: 400 },
				{ type: 'text', key: 'nachname', required: false, width: 400 },
				{ type: 'date', key: 'geburtstag', required: false, width: 400 },
				{ type: 'number', key: 'rolle_id', required: false, width: 400 },
			],
			[
				{ type: 'text', key: 'email', required: false, width: 400 },
				{ type: 'text', key: 'telefon1', required: false, width: 400 },
			],
			[
				{ type: 'text', key: 'strasse', required: false, width: 400 },
				{ type: 'text', key: 'hausnummer1', required: false, width: 400 },
				{ type: 'text', key: 'plz', required: false, width: 400 },
				{ type: 'text', key: 'ort', required: false, width: 400 },
			],
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.DETAIL', routerLink: [this.url + '/' + PATH.DETAIL + '/' + this.id] }
		]);
	}

	setzeAktiv() {
		this.confirmationService.confirm({
			message: this.translate.instant('CONFIRMATION.ACTIVATE_QUESTION'),
			header: this.translate.instant('CONFIRMATION.CONFIRM'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('CONFIRMATION.YES'),
			rejectLabel: this.translate.instant('CONFIRMATION.NO'),
			accept: () => {
				this.internal_AktivInaktiv(true);
			}
		});
	}

	setzeInaktiv() {
		this.confirmationService.confirm({
			message: this.translate.instant('CONFIRMATION.DEACTIVATE_QUESTION'),
			header: this.translate.instant('CONFIRMATION.CONFIRM'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('CONFIRMATION.YES'),
			rejectLabel: this.translate.instant('CONFIRMATION.NO'),
			accept: () => {
				this.internal_AktivInaktiv(false);
			}
		});
	}

	private async internal_AktivInaktiv(value: boolean) {
		this.loading += 1;
		this.crudService.setStaffActiveState(this.entry.ds_this_id, value).then(() => {
			window.location.reload();
		}).catch(err => {
			err.error.forEach(e => {
				if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: 30000 });
				} else {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: 30000 });
				}
			})
		}).finally(() => {
			this.loading -= 1;
		});
	}
}
